import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { APIgetFiles } from '../../api/Files';
import { APIupdateUserSettings } from '../../api/User';

import { getUserSetting } from '../../helpers/Settings';

import LoadingSmall from '../LoadingSmall';

const FileRelatedFiles = ({ profile, file }) => {
  const intl = useIntl();

  const [relatedFiles, setRelatedFiles] = useState([]);
  const [relatedFilesCount, setRelatedFilesCount] = useState(0);
  const [relatedFilesLoading, setRelatedFilesLoading] = useState(true);
  const [relatedFilesOpen, setRelatedFilesOpen] = useState(getUserSetting('related_files_open'));

  const prevUuidRef = useRef();

  useEffect(() => {
    const handleRelatedFiles = () => {
      if (relatedFilesOpen) {
        setRelatedFilesLoading(true);
        APIgetFiles({
          fileUuid: file.uuid,
          per_page: 5,
        }).then((response) => {
          setRelatedFiles(response.data.data.data);
          setRelatedFilesCount(response.data.meta.total);
        }).catch(() => {
          setRelatedFiles([]);
          setRelatedFilesCount(0);
        }).finally(() => {
          setRelatedFilesLoading(false);
        });
      }
    };

    if (prevUuidRef.current !== file.uuid || relatedFilesOpen) {
      handleRelatedFiles();
    }

    prevUuidRef.current = file.uuid;
  }, [file.uuid, relatedFilesOpen]);

  const handleSwitchRelatedFiles = (e) => {
    e.preventDefault();
    APIupdateUserSettings(profile.uuid, { related_files_open: !relatedFilesOpen });
    setRelatedFilesOpen(!relatedFilesOpen);
  };

  return (
    <div className="related-files-wrapper">
      <a href="#switch" onClick={handleSwitchRelatedFiles} className="related-files-btn">
        {relatedFilesOpen ? (
          <i className="far fa-angle-up" />
        ) : (
          <i className="far fa-angle-down" />
        )}
        <span>{intl.formatMessage({ defaultMessage: 'Related files' })}</span>
      </a>
      {relatedFilesOpen && (
        <div className="related-files">
          {relatedFilesLoading ? (
            <LoadingSmall />
          ) : (
            <>
              {relatedFiles.length > 0 ? (
                <ul>
                  {relatedFiles.map(rf => (
                    <li key={rf.uuid}>
                      <Link to={`/files/${rf.uuid}`} target="_blank" className="card-img">
                        <img
                          width="100%"
                          src={rf.urls.thumbnail}
                          srcSet={`${rf.urls.thumbnail} 1x, ${rf.urls.thumbnailx2} 2x`}
                          alt={rf.display_name}
                        />
                      </Link>
                    </li>
                  ))}
                  {relatedFilesCount > 5 && (
                    <li className="related-files-more">
                      <Link to={`/files/related/${file.uuid}`} target="_blank" className="card-img">
                        <i className="fa-regular fa-files" />
                        <span>{intl.formatMessage({ defaultMessage: 'See more' })}</span>
                      </Link>
                    </li>
                  )}
                </ul>
              ) : (
                <div className="related-files-not-found">
                  <span>{intl.formatMessage({ defaultMessage: 'No related files found' })}</span>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

FileRelatedFiles.propTypes = {
  profile: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(FileRelatedFiles);
